import React, { Component } from 'react';
import './css/faq-page.css';

class ContactusPage extends Component {
	constructor(props){
		super(props);
		console.log("FAQs()");
	}
	componentDidMount() {
	}

	componentWillUnmount() {
	}
	
	getQuestionNums() {
		//return Object.keys(window.l10n[window.locale]).filter(x => x.includes("faq.question")).map((x, i) => i+1, {});
		return Object.keys(window.l10n[window.locale]).filter(x => x.match(/faq\.question/gi)).map((x, i) => i+1, {});
	}
	
	render() {
		return(
		<div id="faq-page">
			<div className="banner"/>
			<div className="txt1">{window.l10n[window.locale]["landing.faqs"]}</div>
			<div className="qanda" key="new Date().milliseconds">
				{this.getQuestionNums().map(i => 
					<div key={"qa"+i}>
						<div className="question">{window.l10n[window.locale]["faq.question" + i]}</div>
						<div className="answer">{window.l10n[window.locale]["faq.answer" + i]}</div>
					</div>
				)}
			</div>
		</div>		
		)
	}
}

export default ContactusPage;



// WEBPACK FOOTER //
// ./src/components/faq-page.js